import CommonConstants from '@/common/CommonConstants'
import SessionStorageService from '@/common/SessionStorageService'
import { Component, Vue } from 'vue-property-decorator'
import CABG1010ViewModel from './CABG1010ViewModel'
import CABG1030 from '@/views/CAB/CABG1030/CABG1030.vue'
import CACG1110ParamModel from '@/views/CAC/CACG1110/CACG1110ParamModel'
import CACG1060ParamModel from '@/views/CAC/CACG1060/CACG1060ParamModel'

import CABG1010Service from './CABG1010Service'
import ColorConstants from '@/common/ColorConstants'
import { FormatConstants } from '@/common/FormatConstants'
import 'simplebar'
import 'simplebar/dist/simplebar.css'
import $ from 'jquery'
import ValidateUtil from '@/common/utils/ValidationUtil'
import FixedTableCol from '@/assets/js/components/table.js'
import CommonUtil from '@/common/utils/CommonUtil'
import TransportService from '@/common/TransportService'
import Store from '@/common/utils/Store'
import { fixedContent } from '@/assets/js/main.js'
import { FullPageLoading } from '@/components/common/loading/full-page-loading'

@Component({
  name: 'CABG1010',
  components: {
  CABG1030
  }
  })
export default class CABG1010Controller extends Vue {
  private isCompleteLoading = false
  private CommonConstants = CommonConstants
  private FormatConstants = FormatConstants
  private DEFAULT_YEAR_SELECTED = 0
  private DEFAULT_YEAR_DISPLAY = 1
  private CHANGE_IN_ASSET_BALANCE_SCALE_VALUE = 4
  private referenceDate = ''
  private isFixBalncProductColWidth = false
  private isValueCannotCalculate = false
  private isAddedItemsOtherIncludedFlg = false
  private ValidateUtil = ValidateUtil
  private listProductDiv = [
    '180',
    '050',
    '040',
    '060',
    '030',
    '020',
    '070',
    '100',
    '090',
    '150',
    '160',
    '200',
    '999',
    '190'
  ]

  private cabg1010Service: CABG1010Service = new CABG1010Service()
  private cabg1010ViewModel: CABG1010ViewModel = {
    balncPricEvalValInfo: {
      pensionAssetEvalPric: null,
      pensionAssetEvalPricUnit: '円',
      operatPric: null,
      operatPricUnit: '円',
      evalPl: null,
      evalPlUnit: '円'
    },

    assetDivBalncRatioInfo: {
      distUnit: '',
      distInfoLst: [
        {
          productDivName: '',
          confgRatio: null,
          assetColor: ''
        }
      ]
    },

    productDivEvalPlInfo: {
      balncProductInfoLst: [
        {
          productName: '',
          assetColor: '',
          handProductNo: '',
          ratio: null,
          ratioUnit: '',
          pricEvalVal: null,
          pricEvalValUndeducted: null,
          pricEvalValUnit: '',
          productBalnc: null,
          productBalncUnit: '',
          evalPl: '',
          evalPlUnit: '',
          evalPlRate: '',
          evalPlRateUnit: '',
          getVal: '',
          getValUnit: '',
          pricCritDay: '',
          note: '',
          shhnCd: '',
          rkShhnCd: ''
        }
      ]
    },

    assetBalncTransInfo: {
      assetBalncTransInfoLst: [
        {
          critYearMon: '',
          pensionAssetEvalPric: null,
          pensionAssetEvalPricUnit: '',
          operatPric: null,
          operatPricUnit: '',
          evalPl: null,
          evalPlUnit: '',
          operatYield: null,
          operatYieldUnit: ''
        }
      ]
    },
    assetBalncTransInfoLst: [
      {
        critYearMon: '',
        pensionAssetEvalPric: null,
        pensionAssetEvalPricUnit: '',
        operatPric: null,
        operatPricUnit: '',
        evalPl: null,
        evalPlUnit: '',
        operatYield: null,
        operatYieldUnit: ''
      }
    ],

    dataBalanceRatioByAsset: [],

    dataPensionAssetValuation: [],

    dataOperatingAmount: [],

    dataMappingAssetBalncTransInfo: []
  }

  /**
   * mounted function
   */
  async mounted() {
    fixedContent()
    await this.init()
    FixedTableCol()
    this.$nextTick(() => {
      fixedContent()
      $('.highcharts-range-selector').attr('tabindex', '-1')
    })
    if (this.cabg1010ViewModel.assetBalncTransInfo !==null ||
      this.cabg1010ViewModel.dataOperatingAmount?.length > 0) {
    window.addEventListener('orientationchange', this.refreshPage);
    }
  }

  beforeDestroy() {
    window.removeEventListener('orientationchange', this.refreshPage);
  }

  private refreshPage() {
    location.reload();
  }

  /**
   * init function
   */
  private async init() {
    // 共通メソッド「ローディング表示」を呼び出す。
    const loading = new FullPageLoading()
    loading.show()

    const [
      caba1010ResponseModel,
      caba1011ResponseModel
    ] = await Promise.all([
      this.cabg1010Service.callAPICABA1010(),
      this.cabg1010Service.callAPICABA1011(),
      // システムアクティビティログを実行する（トランスポート）
      TransportService.callAPITransport(CommonConstants.URL_CABG1010, null, null)
    ])

    // 共通メソッド「ローディングクローズ」を呼び出す。
    loading.close()

    if (CommonUtil.isNotEmpty(caba1010ResponseModel.balncPricEvalValInfo)) {
      this.cabg1010ViewModel.balncPricEvalValInfo =
        caba1010ResponseModel.balncPricEvalValInfo
    }
    this.cabg1010ViewModel.assetDivBalncRatioInfo.distUnit =
      caba1010ResponseModel.assetDivBalncRatioInfo?.distUnit

    this.cabg1010ViewModel.assetDivBalncRatioInfo.distInfoLst = []

    if (
      caba1010ResponseModel.balncPricEvalValInfo?.pensionAssetEvalPric ===
        null &&
      caba1010ResponseModel.balncPricEvalValInfo?.operatPric > 0
    ) {
      this.isValueCannotCalculate = true
    }
    if (
      CommonUtil.isNotEmpty(
        caba1010ResponseModel.assetDivBalncRatioInfo?.distInfoLst
      ) &&
      !this.isValueCannotCalculate
    ) {
      this.cabg1010ViewModel.assetDivBalncRatioInfo.distInfoLst =
        caba1010ResponseModel.assetDivBalncRatioInfo?.distInfoLst.map(
          (distInfo, index) => {
            return {
              productDivName: distInfo.productDivName,
              confgRatio: distInfo.confgRatio,
              assetColor:
                ColorConstants.ASSET_CODE[distInfo.productDiv] ??
                ColorConstants.DEFAULT_COLOR
            }
          }
        )
        if (caba1010ResponseModel.isAddedItemsOtherIncludedFlg === '1') {
          this.isAddedItemsOtherIncludedFlg = true
        }
    }

    this.cabg1010ViewModel.productDivEvalPlInfo.balncProductInfoLst = []
    if (
      CommonUtil.isNotEmpty(
        caba1010ResponseModel.productDivEvalPlInfo?.balncProductInfoLst
      )
    ) {
      caba1010ResponseModel.productDivEvalPlInfo.balncProductInfoLst.forEach(
        (balncProduct) => {
          let isLink = false
          if (this.listProductDiv.indexOf(balncProduct.productDiv) >= 0) {
            isLink = true
            if (balncProduct.productDiv === '999') {
              if (
                balncProduct.handProductNo === '999' ||
                balncProduct.productName === '待機資金' ||
                balncProduct.rkShhnCd === null
              ) {
                isLink = false
              }
            }
          }
          const data = {
            productName: balncProduct.productName,
            isLink: isLink,
            handProductNo: balncProduct.handProductNo,
            productDiv: balncProduct.productDiv,
            assetColor:
              ColorConstants.ASSET_CODE[balncProduct.productDiv] ??
              ColorConstants.DEFAULT_COLOR,
            ratio: balncProduct.ratio,
            ratioUnit: balncProduct.ratioUnit,
            pricEvalVal: balncProduct.pricEvalVal,
            pricEvalValUndeducted: balncProduct.pricEvalValUndeducted,
            pricEvalValUnit: balncProduct.pricEvalValUnit,
            productBalnc: balncProduct.productBalnc,
            productBalncUnit: balncProduct.productBalncUnit,
            evalPl: balncProduct.evalPl,
            evalPlUnit: balncProduct.evalPlUnit,
            evalPlRate: balncProduct.evalPlRate,
            evalPlRateUnit: balncProduct.evalPlRateUnit,
            getVal: balncProduct.getVal,
            getValUnit: balncProduct.getValUnit,
            pricCritDay: balncProduct.pricCritDay,
            note: balncProduct.note,
            shhnCd: balncProduct.shhnCd,
            rkShhnCd: balncProduct.rkShhnCd
          }
          if (!(data.productName === '待機資金' && data.pricEvalVal === 0)) {
            this.cabg1010ViewModel.productDivEvalPlInfo.balncProductInfoLst.push(
              data
            )
            if (CommonUtil.isNotEmpty(balncProduct.note)) {
              this.isFixBalncProductColWidth = true
            }
          }
        }
      )
      if (
        this.cabg1010ViewModel.productDivEvalPlInfo.balncProductInfoLst &&
        this.isValueCannotCalculate
      ) {
        this.cabg1010ViewModel.productDivEvalPlInfo.balncProductInfoLst.sort(
          (a, b) => {
            if (a.pricEvalVal > b.pricEvalVal) {
              return -1
            } else if (a.pricEvalVal < b.pricEvalVal) {
              return 1
            }
            if (a.handProductNo > b.handProductNo) {
              return 1
            } else if (a.handProductNo < b.handProductNo) {
              return -1
            }
          }
        )
      }
    }

    if (
      CommonUtil.isNotEmpty(caba1011ResponseModel.assetBalncTransInfo) &&
      CommonUtil.isNotEmpty(
        caba1011ResponseModel.assetBalncTransInfo?.assetBalncTransInfoLst
      ) &&
      CommonUtil.isNotNullArray(
        caba1011ResponseModel.assetBalncTransInfo?.assetBalncTransInfoLst,
        ['pensionAssetEvalPric', 'operatPric', 'evalPl', 'operatYield']
      )
    ) {
      this.cabg1010ViewModel.assetBalncTransInfo =
        caba1011ResponseModel.assetBalncTransInfo
    } else {
      this.cabg1010ViewModel.assetBalncTransInfo = null
    }

    // チャート表示データを準備し
    this.cabg1010ViewModel.dataBalanceRatioByAsset = []
    if (this.cabg1010ViewModel.assetDivBalncRatioInfo.distInfoLst) {
      this.cabg1010ViewModel.assetDivBalncRatioInfo.distInfoLst.forEach(
        (item) => {
          if (item.confgRatio !== 0) {
            const dataChart = {
              color: item.assetColor,
              name: item.productDivName,
              y: item.confgRatio
            }
            this.cabg1010ViewModel.dataBalanceRatioByAsset.push(dataChart)
          }
        }
      )
    }

    if (CommonUtil.isNotEmpty(this.cabg1010ViewModel.assetBalncTransInfo)) {
      this.cabg1010ViewModel.assetBalncTransInfo.assetBalncTransInfoLst.forEach(
        (item) => {
          const tem = new Date(item.critYearMon + '-28').getTime()
          this.cabg1010ViewModel.dataPensionAssetValuation.push([
            tem,
            item.pensionAssetEvalPric
          ])
          this.cabg1010ViewModel.dataOperatingAmount.push([
            tem,
            item.operatPric
          ])
        }
      )
      this.cabg1010ViewModel.dataPensionAssetValuation.sort((a, b) =>
        a[0] < b[0] ? -1 : 1
      )
      this.cabg1010ViewModel.dataOperatingAmount.sort((a, b) =>
        a[0] < b[0] ? -1 : 1
      )
      this.cabg1010ViewModel.dataMappingAssetBalncTransInfo =
        this.cabg1010Service.createMappingAssetBalncTransInfo(
          this.cabg1010ViewModel.assetBalncTransInfo.assetBalncTransInfoLst
        )
      this.cabg1010ViewModel.assetBalncTransInfoLst =
        this.cabg1010Service.clickChangeYear(
          this.DEFAULT_YEAR_DISPLAY,
          this.cabg1010ViewModel.assetBalncTransInfo.assetBalncTransInfoLst
        )
    }

    const userInfo = JSON.parse(
      SessionStorageService.getItem(CommonConstants.USER_INFO)
    ).userInfo
    this.referenceDate = userInfo.referenceDate

    this.isCompleteLoading = true
  }

  /**
   * 資産残高の推移ボタン押下
   * @param yearNum
   */
  public async clickChangeYear(yearNum) {
    const dataApi =
      this.cabg1010ViewModel.assetBalncTransInfo.assetBalncTransInfoLst
    const dataReturn = this.cabg1010Service.clickChangeYear(yearNum, dataApi)
    this.cabg1010ViewModel.assetBalncTransInfoLst = dataReturn as any
  }

  /**
   * 運用状況（掛金）（CABG1020）画面に遷移する。
   */
  private gotoCABG1020() {
    this.$router.push({ name: 'cabg1020' })
  }

  /**
   * 運用状況（利回り）（CABG1030）画面に遷移する。
   */
  private gotoCABG1030() {
    this.$router.push({ name: 'cabg1030' })
  }

  /**
   *  外部サイト：JIS＆Tログインを別タブで表示する。
   * @param transportUrl
   */
  private gotoJIST(transportUrl, paramEvent) {
    if (CommonUtil.isGuestUser()) {
      const message = CommonUtil.getMessage('MSGCABG1010WF001', [])
      const messageErrorArr = []
      messageErrorArr.push({
        code: 'MSGCABG1010WF001',
        message: message,
        url: ''
      })
      Store.setResponseErrors(messageErrorArr)
    } else {
      TransportService.callAPITransport(transportUrl, null, null)
      CommonUtil.gotoJISTSite(paramEvent)
    }
  }

  /**
   * 商品分類に紐づく、該当する商品詳細画面に遷移する。
   * @param handProductNo
   * @param productDiv
   * @param shhnCd
   * @param productName
   * @param rkShhnCd

   */
  private gotoProductDetail(
    handProductNo: string,
    productDiv: string,
    shhnCd: string,
    productName: string,
    rkShhnCd: string
  ) {
    const cacg1110ParamModel: CACG1110ParamModel = {
      productNo: rkShhnCd,
      shhnCd: shhnCd
    }

    const cacg1060ParamModel: CACG1060ParamModel = {
      productNo: rkShhnCd,
      shhnCd: shhnCd
    }
    switch (productDiv) {
      case '180':
        this.$router.push({ name: 'cacg1110', query: cacg1110ParamModel })
        break
      case '020':
      case '030':
      case '040':
      case '050':
      case '060':
      case '070':
      case '090':
      case '100':
      case '150':
      case '190':
        this.$router.push({ name: 'cacg1060', query: cacg1060ParamModel })
        break
      case '999':
        if (handProductNo !== '999' && productName !== '待機資金') {
          this.$router.push({ name: 'cacg1060', query: cacg1060ParamModel })
          break
        }
    }
  }
}
